import { Component, OnInit, ComponentRef } from '@angular/core';
import { IModalDialog, IModalDialogOptions, IModalDialogButton } from 'ngx-modal-dialog';
import { ApiService } from '../../../services/api.service';
import { Product } from '../../../models/product';
import { UtilsService } from '../../../services/utils.service';
import { AlgGtmService } from '../../../services/alg-gtm.service';

@Component({
  selector: 'custom-modal',
  templateUrl: './custom-modal.component.html',
  styleUrls: ['./custom-modal.component.scss']
})
export class CustomModalComponent implements OnInit, IModalDialog {
  public product: Product;
  public greenEnergy: boolean = false;
  parentInfo: string;
  actionButtons: IModalDialogButton[];

  constructor(private api: ApiService, private utils: UtilsService, private gtm: AlgGtmService) {
    this.actionButtons = [
      { text: '', buttonClass: 'alg-btn-close',  onAction: () => {
          this.api.refreshCurrentProduct();
          this.utils.abilityOverflow();
          return true;
        }
      }, // no special processing here
      { text: 'No, non cambio', buttonClass: 'button-cancel-product', onAction: () => {
          this.api.refreshCurrentProduct();
          this.utils.abilityOverflow();
          return true;
        }
      },{ text: 'aggiorna', buttonClass: 'button-reload-product', onAction: () => {
        this.gtm.submitOnbEvent('Modifica Offerta', this.product.name);
        this.api.nextToCurrentProduct();
        this.utils.abilityOverflow();
        return true;
      }
    }];
  }

  ngOnInit() {
    this.api.nextProduct
      .combineLatest(this.api.currentLightGreen)
      .subscribe(([product, lightGreen]) => {
        this.product = product;
        this.greenEnergy = lightGreen
    });
  }

  dialogInit(reference: ComponentRef<IModalDialog>, options: Partial<IModalDialogOptions<string>>) {
    
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dialogs/custom-modal/custom-modal.component.ts